/**
 * ProfileInfoCard Component
 * Reusable card component for displaying profile information
 * Follows the theme from OurTeam page
 */

import React from 'react';
import Card, { CardContent } from './Card';
import styles from './ProfileInfoCard.module.css';

const ProfileInfoCard = ({
  title,
  subtitle,
  variant = 'default', // 'default', 'green', 'contrast' (text only, no background)
  children,
  className = '',
  ...props
}) => {
  const cardVariant = 'transparent';
  const headerClass = variant === 'green'
    ? styles.headerGreen
    : variant === 'contrast'
    ? styles.headerContrast
    : styles.headerDefault;

  return (
    <Card
      variant={cardVariant}
      className={`${styles.profileCard} ${className}`}
      {...props}
    >
      <CardContent>
        {title && (
          <div className={headerClass}>
            <h3 className={styles.title}>{title}</h3>
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>
        )}
        <div className={styles.content}>
          {children}
        </div>
      </CardContent>
    </Card>
  );
};

export default ProfileInfoCard;
